import { Link } from 'react-router-dom';

const services = [
  { num: '01', icon: 'ri-heart-pulse-line', title: 'Preventive Care', desc: 'Annual wellness exams, screenings, and immunizations to keep you healthy before illness strikes.' },
  { num: '02', icon: 'ri-stethoscope-line', title: 'Chronic Disease Management', desc: 'Personalized care plans for diabetes, hypertension, asthma, and other long-term conditions.' },
  { num: '03', icon: 'ri-parent-line', title: 'Pediatric Care', desc: 'Comprehensive health services for children from newborns through adolescence.' },
  { num: '04', icon: 'ri-user-heart-line', title: 'Senior Primary Care', desc: 'Specialized care addressing the unique health needs of adults 65 and older.' },
  { num: '05', icon: 'ri-computer-line', title: 'Telehealth Visits', desc: 'Convenient virtual appointments from the comfort of your home — same great care.' },
  { num: '06', icon: 'ri-mental-health-line', title: 'Behavioral Health', desc: 'Integrated mental health support, counseling referrals, and wellness coaching.' },
];

export default function ServicesPreview() {
  return (
    <section className="py-28 bg-zinc-50">
      <div className="px-8 md:px-16 lg:px-24">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-20 gap-8">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-8 h-px bg-rose-500"></div>
              <span className="text-rose-500 text-xs font-semibold uppercase tracking-[0.25em]">What We Offer</span>
            </div>
            <h2
              className="text-4xl md:text-6xl font-black text-zinc-900 leading-tight"
              style={{ fontFamily: "'Syne', sans-serif" }}
            >
              Full-Spectrum<br />Primary Care
            </h2>
          </div>
          <div className="lg:max-w-xs">
            <p className="text-zinc-500 text-sm leading-relaxed mb-6">
              From routine checkups to complex chronic conditions, our board-certified physicians provide the full spectrum of primary care services under one roof.
            </p>
            <Link
              to="/services"
              className="inline-flex items-center gap-2 text-zinc-900 font-semibold text-sm border-b-2 border-rose-500 pb-0.5 hover:border-zinc-900 transition-colors cursor-pointer whitespace-nowrap"
            >
              View all services
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div className="divide-y divide-zinc-200">
          {services.map((svc) => (
            <div
              key={svc.title}
              className="group flex flex-col md:flex-row md:items-center gap-6 py-8 hover:bg-white hover:-mx-8 hover:px-8 md:hover:-mx-16 md:hover:px-16 lg:hover:-mx-24 lg:hover:px-24 transition-all duration-300 cursor-pointer"
            >
              <span
                className="text-zinc-200 font-black text-5xl md:text-6xl w-20 shrink-0 group-hover:text-rose-200 transition-colors"
                style={{ fontFamily: "'Syne', sans-serif" }}
              >
                {svc.num}
              </span>
              <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-zinc-100 group-hover:bg-rose-50 transition-colors shrink-0">
                <i className={`${svc.icon} text-xl text-zinc-400 group-hover:text-rose-500 transition-colors`}></i>
              </div>
              <div className="flex-1">
                <h3
                  className="text-xl font-bold text-zinc-900 mb-1"
                  style={{ fontFamily: "'Syne', sans-serif" }}
                >
                  {svc.title}
                </h3>
                <p className="text-zinc-500 text-sm leading-relaxed">{svc.desc}</p>
              </div>
              <div className="w-10 h-10 flex items-center justify-center rounded-full border border-zinc-200 group-hover:border-rose-500 group-hover:bg-rose-500 transition-all shrink-0">
                <i className="ri-arrow-right-line text-zinc-400 group-hover:text-white transition-colors"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
